<thr-loading [show]="loader.isLoading()"></thr-loading>
<thr-header-operative [agent]="user" [showBack]="showBack" (back)="onBack()" *ngIf="showHeader && !isClientPortal">
    <span class="mr-3" *ngIf="contract">
        {{ 'header.contract-number'|translate }}:
        <strong>{{ contract.bankCode }}</strong>
    </span>
</thr-header-operative>
<thr-header-onboarding-client-portal
    [user]="user"
    [showBack]="showBack"
    (back)="onBack()"
    *ngIf="showHeader && isClientPortal"
></thr-header-onboarding-client-portal>

<router-outlet></router-outlet>
